import React from "react";

function Home() {
  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          height: "100vh",
          width: "100vw",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div className="text-center text-white">
          <h1
            className="display-1 fw-bold mb-4"
            style={{ animation: "fadeInDown 1s ease-out" }}
          >
            Coming Soon
          </h1>
          <p
            className="lead mb-4"
            style={{ animation: "fadeInUp 1s ease-out 0.3s both" }}
          >
            We're working on something amazing. Stay tuned!
          </p>
          {/* <div style={{ animation: "fadeInUp 1s ease-out 0.6s both" }}>
            <a
              href="/landing-page"
              className="btn btn-light btn-lg rounded-pill px-5"
            >
              <i className="mdi mdi-eye me-2"></i>
              Preview Landing Page
            </a>
          </div> */}
        </div>
      </div>
      <style>
        {`
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </>
  );
}

export default Home;
